// import { mapActions } from 'vuex';

export default {
  data() {
    return {}
  },
  computed: {},
  methods: {
    // ...mapActions([]),
  }
}